export default __webpack_public_path__ + "static/media/speed.b73e7b3a.svg";